import OrderSummary from './order-summary';
import PickList from './pick-list';
import PackingSlip from './packing-slip';
import ShipmentManifest from './shipment-manifest';
import Label from './label';

import { DocumentType } from '../../../../enums/document-type';

const docTypeToPrintSettingsModalMap = {
  [DocumentType.OrderSummary.identifier]: OrderSummary,
  [DocumentType.PickList.identifier]: PickList,
  [DocumentType.PackingSlip.identifier]: PackingSlip,
  [DocumentType.ShipmentManifest.identifier]: ShipmentManifest,
  [DocumentType.Label.identifier]: Label,
};

export default docTypeToPrintSettingsModalMap;
